import React, { useEffect, useState } from 'react';

import { Check } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';

import CustomSnackbar from '../../uiParts/CustomSnackbar';
import SideBar from '../../uiParts/SideBar';
import { gray100 } from '../../../constants/Colors';
import { sideBarWidth, spHeaderHeight } from '../../../constants/Location';
import { browserBack } from '../../../modules/error';
import CustomHead from '../CustomHead';

const styles = {
  container: {
    '@media screen and (min-width:961px)': {
      ml: sideBarWidth,
      height: '100vh'
    },
    '@media screen and (max-width:960px)': {
      mt: spHeaderHeight
    },
    direction: 'column',
    justifyContent: 'center',
    height: `calc(100vh - ${spHeaderHeight})`,
    minHeight: '100vh'
  },
  body: {
    '@media screen and (max-width:600px)': {
      width: '343px',
      mt: '81px'
    },
    textAlign: 'center',
    maxWidth: '431px',
    width: '95%',
    alignItems: 'center',
    mt: '160px'
  },
  checkIcon: {
    '@media screen and (max-width:600px)': {
      height: '64px'
    },
    height: '80px',
    width: '100%',
    color: gray100
  },
  title: {
    '@media screen and (max-width:600px)': {
      m: '16px auto 0'
    },
    fontWeight: 500,
    color: gray100,
    fontSize: '24px',
    mt: '16px',
    textAlign: 'center'
  },
  text: {
    fontSize: '16px',
    color: gray100,
    mt: '24px',
    textAlign: 'center',
    fontWeight: 400
  }
};

const AccountWithdrawalComplete: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>('');

  const browserBackAlert = (e: { preventDefault: () => void }): void => {
    e.preventDefault();
    setOpen(true);
    setErrorText(browserBack);
    window.history.pushState(null, '', window.location.pathname);
  };

  useEffect(() => {
    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', browserBackAlert);
    return () => {
      window.removeEventListener('popstate', browserBackAlert);
    };
  }, []);

  return (
    <>
      <CustomHead title="退会申請完了 | CMCOS[コムコス]" />
      <Grid container>
        <SideBar />
        <Grid container sx={styles.container}>
          <Grid item sx={styles.body}>
            <Check sx={styles.checkIcon} />
            <Typography sx={styles.title}>退会が完了しました</Typography>
            <Typography sx={styles.text}>
              CMCOSをご利用いただき、ありがとうございました。
              <br />
              退会完了メールを送信しておりますので、ご確認ください。
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
        text={errorText}
      />
    </>
  );
};

export default AccountWithdrawalComplete;
